module.exports = __webpack_public_path__ + "img/person-img5.545a4fb5.png";